import { PROTEOFORM_DEFAULT_THRESHOLD_CPM } from '@/constants';
import type { SampleProteoformSearchRequest } from '@/types';

export const PROTEOFORM_SEARCH_BODY: SampleProteoformSearchRequest = {
  skip: 0,
  limit: 100,
  sort_by: 'proteoform_name',
  sort_order: 'desc',
  threshold_cpm: PROTEOFORM_DEFAULT_THRESHOLD_CPM,
};
